import HouseBillNote from './components/bill/HouseBillNote'
import HouseBillItem from './components/HouseBillItem'
import MasterBillInfo from './components/MasterBillInfo'
import SearchFilterV2 from './components/SearchFilterV2'
import { useMasterBillState } from './stores/useMasterBillStore'


const MasterBill: React.FC = () => {
  const { houseBills } = useMasterBillState()

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4">
      <div className="space-y-2 md:space-y-4">
        <SearchFilterV2 />
        {/* 主提单信息组件 */}
        <MasterBillInfo />
      </div>
      <div className="space-y-2 overflow-y-auto h-full max-h-[60vh] md:max-h-full">
        {houseBills.length === 0 && (
          <div className="w-full min-h-40 flex justify-center items-center text-sm md:text-base">请选择一个主提单</div>
        )}

        {houseBills?.map((houseBill, index) => (
          <HouseBillItem
            key={houseBill.id}
            houseBill={houseBill}
            index={index}
          />
        ))}
      </div>
      {/* 备注编辑对话框 */}
      <HouseBillNote />
    </div>
  )
}

export default MasterBill
